<template>
    <div class="uploader-contact-step">
        <form class="uploader-form uploader-contact-form" @submit.prevent="checkForm" novalidate>
            <div class="uploader-field-grid uploader-contact-names">
                <div class="uploader-field">
                    <label for="inputFirstname">{{ $t('first_name') }}</label>
                    <input type="text" class="form-control" id="inputFirstname" :placeholder="this.$t('first_name')" autocomplete="given-name" v-model="firstname" :disabled="isSending">
                </div>
                <div class="uploader-field">
                    <label for="inputLastname">{{ $t('last_name') }}</label>
                    <input type="text" class="form-control" id="inputLastname" :placeholder="this.$t('last_name')" autocomplete="family-name" v-model="lastname" :disabled="isSending">
                </div>
            </div>

            <div class="uploader-field uploader-contact-email">
                <label for="inputEmail">{{ $t('email_address') }}</label>
                <input type="email" class="form-control" id="inputEmail" placeholder="user@example.com" autocomplete="email" inputmode="email" v-model="email" :disabled="isSending">
            </div>
            <div class="uploader-field uploader-contact-message">
                <label for="inputMessage">{{ $t('your_message') }}</label>
                <textarea rows="4" class="form-control" id="inputMessage" :placeholder="this.$t('your_message_placeholder')" v-model="message" :disabled="isSending"></textarea>
            </div>
            <div class="uploader-field uploader-check uploader-contact-partial">
                <input type="checkbox" class="form-check-input" id="inputTeilmosaik" v-model="teilmosaic_checked" :disabled="isSending">
                <label for="inputTeilmosaik">{{ $t('as_partial_mosaic') }}</label>
            </div>
            <div class="uploader-field uploader-contact-partial-message" v-show="teilmosaic_checked">
                <label for="inputTeilmosaikMessage">{{ $t('partial_mosaic_label') }}</label>
                <textarea rows="4" class="form-control" id="inputTeilmosaikMessage" :placeholder="this.$t('partial_mosaic_placeholder')"  v-model="teil_message" :disabled="isSending"></textarea>
            </div>
            <div v-if="errors.length" class="alert-uploader uploader-note" role="alert">
                <b>{{ $t('fix_errors') }}</b>
                <ul>
                    <li v-bind:key="error.message" v-for="error in errors">{{ error.message }}</li>
                </ul>
            </div>

            <div class="uploader-actions">
                <button v-if="this.$store.getters.step > 1" type="button" class="btn-uploader btn-uploader-dark" @click="$store.dispatch('DECREMENT')" :disabled="isSending">
                    {{ $t('back') }}
                </button>
                <button type="submit" class="btn-uploader" v-if="this.$store.getters.step < 5" :disabled="isSending">
                    {{ $t(isSending ? 'design_saving' : 'submit') }}
                </button>
            </div>

        </form>
    </div>
</template>

<script>
    import PreviewService from "@/services/preview.service";
    import UploadLog from "@/services/upload-log.service";
    import * as types from "@/store/mutation-types";

    export default {
        name: "StepFour",
        data: function() {
            return {
                errors: [],
                isValid: true,
                isSending: false,
                firstname: null,
                lastname: null,
                email: this.$store.getters.email || null,
                message: "",
                teil_message: "",
                teilmosaic_checked: false
            }
        },
        mounted() {
            const vm = this;
            this.$nextTick(() => {
                vm.$emit('scroll-to-app');
            });
        },
        methods: {
            validateEmail: function(email) {
                const re = /\S+@\S+\.\S+/;
                return re.test(String(email).toLowerCase());
            },
            checkForm: function() {
                if(this.validateEmail(this.email)) {
                    if(this.teilmosaic_checked && this.teil_message.length > 0) {
                        this.isValid = true;
                        this.errors = [];
                        this.sendUpdate();
                    } else if(this.teilmosaic_checked && this.teil_message.length === 0) {
                        this.isValid = false;
                        this.errors = [
                            {"message": this.$t('partial_mosaic_required')}
                        ];
                    } else {
                        this.isValid = true;
                        this.errors = [];
                        this.sendUpdate();
                    }
                } else {
                    this.isValid = false;
                    this.errors = [
                        {"message": this.$t('email_invalid')}
                    ];
                    UploadLog.log('contact_email_invalid');
                }
                return false;
            },
            sendUpdate: function() {
                var vm = this;
                if(!vm.isSending) {
                    if(Object.prototype.hasOwnProperty.call(window, 'dataLayer') && Array.isArray(window.dataLayer)) {
                        window.dataLayer.push({
                            'event': 'preview-created'
                        });
                    }
                    vm.isSending = true;
                    UploadLog.log('contact_submitted', {
                        has_name: Boolean(vm.firstname || vm.lastname),
                        has_message: Boolean(vm.message),
                        partial_mosaic: vm.teilmosaic_checked,
                        email_changed: vm.email !== vm.$store.getters.email
                    });
                    PreviewService.update({
                        code: vm.$store.getters.preview,
                        vorname: vm.firstname,
                        nachname: vm.lastname,
                        teilmosaik: vm.teilmosaic_checked,
                        email: vm.email,
                        message: vm.message,
                        teilmosaik_message: vm.teil_message
                    }).then(function() {
                        return PreviewService.finish({
                            code: vm.$store.getters.preview
                        });
                    }).then(function() {
                        vm.isValid = true;
                        vm.isSending = false;
                        vm.$store.dispatch(types.SET_EMAIL, { email: vm.email });
                        vm.$store.dispatch(types.INCREMENT);
                    }).catch(function(error) {
                        console.log((error.response && error.response.data) ||
                            error.message ||
                            error.toString());
                        UploadLog.logError('finish_failed', error);
                        vm.isValid = false;
                        vm.isSending = false;
                        vm.errors = [
                            {"message": vm.$t('submit_failed')}
                        ];
                    });
                }

            }
        }
    }
</script>

<style scoped>
</style>
